import {
  TIME_SELECTOR_DATE_CHANGED,
} from "./constants";

export const setTimeSelectorDateChange = (change) => ({
  type: TIME_SELECTOR_DATE_CHANGED,
  change
});